// @ts-nocheck

import { reducerWrapper } from '../../main/support/utils';
import { GET_USER_APP_TERMS, UPDATE_USER_APP_TERM } from '../actions/UserEntityTermsActions';
import type { Term, UserAppTerms, UserEntityTermsReducer } from '../types/userEntityTermsTypes';
export const INIT_STATE: UserEntityTermsReducer = {
  userAppTerms: undefined,
  loading: false,
};

function mergeUpdatedUserAppTermIntoTerms(updatedUserAppTerm: Term, userAppTerms?: UserAppTerms): UserAppTerms {
  if (!userAppTerms) {
    return [updatedUserAppTerm];
  }

  const updatedTermExists = userAppTerms.find((term) => term.resource === updatedUserAppTerm.resource);

  if (!updatedTermExists) {
    return [...userAppTerms, updatedUserAppTerm];
  }

  return userAppTerms.map((term) => {
    if (term.resource === updatedUserAppTerm.resource) {
      return updatedUserAppTerm;
    }

    return term;
  });
}

function Handler(state, action) {
  switch (action.type) {
    case GET_USER_APP_TERMS.response:
      return { ...state, userAppTerms: action.data, loading: false };

    case UPDATE_USER_APP_TERM.response:
      return { ...state, userAppTerms: mergeUpdatedUserAppTermIntoTerms(action.data, state.userAppTerms) };

    default:
      return state;
  }
}

export default reducerWrapper(INIT_STATE, Handler, {
  request: [GET_USER_APP_TERMS],
  error: [GET_USER_APP_TERMS],
  resetOn: ['APP_CHANGE'],
});
